<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Emissão: Nova avulsa
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  emitir uma OS avulsa
        |  —
        strong  sem vínculo com cadastro
        |  — informando o endereço diretamente.

      .toast.toast-primary
        | A opção
        strong  Nova avulsa
        |  exige a permissão
        strong  Ordem serviços → Criar
        | .

      h5.h5 1. Abrir o formulário
      ol
        li Em
          strong  OS-m → Serviços
          | , clique no
          strong  +
          | .
        li Escolha
          strong  Nova avulsa
          | .
      figure.manual-figure
        img(:src="imgMenu" alt="Menu + com opções de emissão de OS")

      h5.h5 2. Preencher a Nova OS Avulsa
      figure.manual-figure
        img(:src="imgForm" alt="Formulário Nova OS Avulsa")
      p Diferença em relação à
        strong  Nova
        | : não há campo de cadastro nem vínculo de documento. É obrigatório
        |  informar o
        strong  endereço
        | .
      ol
        li
          strong Assunto
          |  (obrigatório).
        li
          strong Situação
          |  e
          strong  Fiscal
          | .
        li
          strong Analista
          |  — se o assunto permitir análise.
        li
          strong Endereço
          |  — clique em
          em Informe um endereço para a OS-m
          |  e busque/selecione o local.
        li
          strong Protocolo
          |  (tipo, número, ano, data),
          strong  Prazo
          |  e
          strong  É necessário agendar
          | .
        li
          strong Observações
          |  (obrigatório neste fluxo) e checklist extra, se houver.

      h5.h5 3. Salvar
      ol
        li Clique em
          strong  Salvar
          | .
        li Após o sucesso, o sistema abre a OS criada.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/06-osm-emissao-menu.png"),
      imgForm: require("@/assets/manuais/06b-osm-emissao-avulsa.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
